<template>
  <div :class="[className]">
    <nav aria-label="breadcrumb">
      <ol v-if="!pathList" class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link
            to="/"
            alt="Home"
            aria-label="Link para Home"
            class="color--info"
          >
            <Icon name="house" class="color--info" />
          </router-link>
        </li>

        <li class="breadcrumb-item">
          <router-link :to="`/${routeHome}`" name="home" class="color--info">
            <span>Emissão de certificado</span>
          </router-link>
        </li>

        <li class="breadcrumb-item active">
          <router-link to="/birdId/voucher" class="color--primary">
            <span>BirdID</span>
          </router-link>
        </li>
      </ol>

      <ol v-else class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link
            to="/"
            alt="Home"
            aria-label="Link para Home"
            class="color--info"
          >
            <Icon name="house" class="color--info" />
          </router-link>
        </li>
        <li
          v-for="(url, name) in pathList"
          :key="name"
          :class="[
            'breadcrumb-item',
            { active: name == lastElementOfPathList },
          ]"
        >
          <router-link
            :to="`/${url}`"
            name="home"
            :class="[
              name == lastElementOfPathList ? 'color--primary' : 'color--info',
            ]"
          >
            <span>{{ name }}</span>
          </router-link>
        </li>
      </ol>
    </nav>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { mapState } from 'pinia'
  import { useAR } from '@/store/Pinia/useAR.store'
  import Icon from '../Atoms/Icon.vue'

  export default defineComponent({
    name: 'BreadCrumbs',
    props: {
      pathList: {
        type: Object,
        default: () => undefined,
      },
      className: {
        type: String,
        default: 'py-3',
      },
    },
    data: () => ({
      subdomain: '',
    }),
    mounted() {
      this.subdomain = this.arData.subdomain || ''
    },
    computed: {
      ...mapState(useAR, ['arData']),
      routeHome() {
        return this.subdomain ? this.subdomain : ''
      },
      lastElementOfPathList() {
        const objKey = Object.keys(this.pathList as string[])
        return objKey[objKey.length - 1]
      },
    },
    components: {
      Icon,
    },
  })
</script>

<style scoped></style>
